export default __webpack_public_path__ + "header-extrusion.svg";